import {
  endOfDay,
  toCapitalizeCase,
  useLocalStorage,
  useMyUrl,
  useTranslation,
  yesterday,
} from '@gimlite/common';
import { Main, useStoreUIV1 } from '@gimlite/ui-v1';
import IEM from '@gimlite/ui-v1/assets/logo/IEM_small';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Query } from '../client/graphql';
import LogoIEMPrestoScan from './assets/logo/iem-prestoscan';
import { truncateString } from './common/fun/string';

const MainUse = observer(() => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { buildParamsUrl } = useMyUrl();
  const { t, lang }: any = useTranslation();
  const { SSOStore } = useStoreUIV1();
  const [minUncoveredDuration] = useLocalStorage(
    'minUncoveredDuration',
    undefined,
  );
  const { MenuStore } = useStoreUIV1();

  const me = SSOStore.user as Query['me'];

  const eventsDefaultParams = {
    startDate: yesterday('DATE'),
    endDate: endOfDay('DATE'),
    cameraId: 'all',
    way: 'all',
    knownLpn: 'yes',
    isVehicle: 'yes',
  };

  useEffect(() => {
    if (me) {
      const { data, lang } = me;

      if (pathname === '/' && data.ups)
        navigate(
          `/${data.ups[0]?._id}/events?${buildParamsUrl(eventsDefaultParams)}`,
        );
    }
  }, [me, eventsDefaultParams]);

  useEffect(() => {
    if (me && me.data.ups) {
      const { data } = me;

      const multipleCities =
        [
          ...new Set(
            data.ups.map((ups) => ups?.address?.postalCode).filter(Boolean),
          ),
        ].length > 1;

      const vaoDefaultParams = {
        minUncoveredDuration: minUncoveredDuration,
      };

      MenuStore.setMenu([
        {
          key: 'top',
          position: 'top',
          title: `${t('allParkingLots')} (${data.ups.length})`,
          items: data.ups
            .map(({ _id, address, ...rest }) => {
              const translate =
                multipleCities && address?.addressLocality
                  ? `${address?.addressLocality} - ${t(`ups-${_id}-name`)}`
                  : t(`ups-${_id}-name`);
              return {
                _id,
                address,
                translate: truncateString(translate, 27),
                translateTooltip: translate,
                ...rest,
              };
            })
            .sort((a, b) =>
              a.translate
                .toLocaleLowerCase()
                .localeCompare(b.translate.toLocaleLowerCase()),
            )
            .map(({ _id, translate, config, translateTooltip }) => {
              const vaoParams = {
                ...vaoDefaultParams,
                maxSessionDurationInHours:
                  config?.prestoScan?.maxSessionDurationInHours ?? undefined,
              };
              const items: any[] = [
                {
                  key: `/${_id}/events`,
                  params: eventsDefaultParams,
                  label: toCapitalizeCase(t('entries/exits')),
                  icon: 'faCarSolid',
                },
                {
                  key: `/${_id}/vao`,
                  params: vaoParams,
                  label: `${t('vao')}`.toUpperCase(),
                  icon: 'faCameraSolid',
                },
              ];

              // if (config?.prestoScan?.canShowOccupancy)items.push({
              //   key: `/${_id}/occupancy`,
              //   label: `${t('occupancy')}`.toUpperCase(),
              //   icon: <PieChartFilled style={{ fontSize: '24px' }} />,
              // });

              return {
                key: `/${_id}/events`,
                label: translate,
                icon: 'faSquareParkingSolid',
                items,
                tooltip: translateTooltip,
              };
            }),
        },
      ]);
    }
  }, [me, lang, minUncoveredDuration]);

  return me ? (
    <Main
      handleEvent={{
        selected: (key: string) => {
          navigate(key);
        },
      }}
      config={{
        navigation: {
          logo: LogoIEMPrestoScan(),
          mode: 'drop',
        },
        //! Lors d'une refact du router, ce code apparaitra une fois en global (PROBLEM 1)
        //******* START ************/
        header: {
          logo: IEM(),
        },
        //******* STOP ************/
      }}
    />
  ) : null;
});

export default MainUse;
